// extracted by mini-css-extract-plugin
export default {"wrapper":"SubscriptionsProfiles_wrapper__S7SZ4","profileList":"SubscriptionsProfiles_profileList__5S-SF"};